import { render, staticRenderFns } from "./PanelMain.vue?vue&type=template&id=5caa3091&scoped=true"
import script from "./PanelMain.vue?vue&type=script&lang=js"
export * from "./PanelMain.vue?vue&type=script&lang=js"
import style0 from "./PanelMain.vue?vue&type=style&index=0&id=5caa3091&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa3091",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5caa3091')) {
      api.createRecord('5caa3091', component.options)
    } else {
      api.reload('5caa3091', component.options)
    }
    module.hot.accept("./PanelMain.vue?vue&type=template&id=5caa3091&scoped=true", function () {
      api.rerender('5caa3091', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/list/PanelMain.vue"
export default component.exports